import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator.js';

function LoadingBlur(_ref) {
  let {
    loading,
    className,
    style,
    children,
    contrast,
    variant = 'orbit'
  } = _ref;
  return jsxs(Fragment, {
    children: [loading ? jsxs("div", {
      className: ['loading-blur-container overflow-hidden', variant === 'ripple' ? 'loading-blur-ripple-mode' : undefined, className, contrast ? 'contrast' : undefined].join(' '),
      style: style,
      children: [jsx("div", {
        className: ['loading-blur', variant === 'ripple' ? 'loading-blur-ripple' : undefined].join(' '),
        style: style
      }), variant === 'ripple' ? jsx(LoadingIndicator, {
        variant: "ripple"
      }) : jsx("div", {
        className: "orbit"
      })]
    }) : null, children]
  });
}

export { LoadingBlur };
